<template>
    <div :class="styleMain">
      <el-select v-model="category" placeholder="">
        <el-option v-for="cat in categories" :key="cat.id" :label="cat.label" :value="cat" />
      </el-select>
    </div>
</template>

<script>
import { actionCategories } from '@/store/model/sport/football/ActionCategories'

export default {
  name: 'SportFootballMatchActionCategory',
  props: {
    action: Object
  },
  computed: {
    categories () { return actionCategories.listDisplaySelect },
    category: {
      get () { return this.action.category.label },
      set (category) {
        const data = {
          id: this.action.id
        }

        Object.assign(data, category.rules)
        if (category.rulesPost) {
          Object.assign(data, category.rulesPost)
        }

        this.$store.dispatch('Sport/Football/Match/putAction', data)
      }
    },

    styleMain () {
      return [
        'sportFootballMatchActionCategory',
        this.action.homeAway,
        [21, 22].indexOf(this.action.typeId) > -1 ? 'timeout' : null
      ]
    }
  }
}
</script>

<style>
.sportFootballMatchActionCategory {
  grid-area: category;
}
.sportFootballMatchActionCategory > div {
  width:100%
}
.sportFootballMatchActionCategory input{
  font-weight:600;
  height:35px;
  border:none;
  text-align: left;
  line-height:16px;
  white-space: normal;
}
.sportFootballMatchActionCategory.home input{
  background-color: var(--color-team-home);
  color:white
}
.sportFootballMatchActionCategory.away input{
  background-color: var(--color-team-away);
  color:white
}
.sportFootballMatchActionCategory.timeout input{
  background-color: var(--color-background-offset-dark);
  color:white
}
</style>
